const DEFAULT_DELAY = 6000

export default {
  namespaced: true,
  state: {
    notifications: []
  },
  getters: {
    notifications: state => state.notifications
  },
  mutations: {
    addNotification(state, notification) {
      state.notifications.push(notification)
    },
    resetNotification(state, id) {
      state.notifications = state.notifications.filter(notification => notification.id !== id)
    }
  },
  actions: {
    setNotification({ commit, state }, { type, title, description, delay = DEFAULT_DELAY }) {
      const id = Date.now()
      commit('addNotification', { id, type, title, description, delay })

      setTimeout(() => {
        commit('resetNotification', id)
      }, delay)
    }
  }
}
